import { AppState } from '../../../../store/app.states';
import { employerViewOverview_Model } from './selectors';
import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { RequestAction } from './actions';
import { ComponentBase } from '../../../../views/component-base';
import { EmployerPortalSharedState } from '../../store/shared.states';
import { Router } from '@angular/router';
import { commomState_SystemConfig_Config } from 'src/app/store/common/common.selectors';

@Component({
  selector: 'app-employer-view-overview',
  templateUrl: './employer-view-overview.component.html',
  styleUrls: ['./employer-view-overview.component.scss']
})
export class EmployerViewOverviewComponent extends ComponentBase implements OnInit, OnDestroy {

  data$ = this.store.pipe(select(employerViewOverview_Model));
  tenantConfig$ = this.appstore.pipe(select(commomState_SystemConfig_Config));

  @Input() itemclass: string = 'w-50';

  constructor(
    public store: Store<EmployerPortalSharedState>,
    public appstore: Store<AppState>,
    private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.store.dispatch(RequestAction());

    this.screenWidthChange(this.appstore, x => { });

  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  personalDetails() {
    this.router.navigate(['employer-edit']);
  }

  changePassword() {
    this.router.navigate(['change-password']);
  }
}
